const FETCH_STANDINGS_INITIATED = 'FETCH_STANDINGS_INITIATED';
const FETCH_STANDINGS_SUCCEEDED = 'FETCH_STANDINGS_SUCCEEDED';
const FETCH_STANDINGS_FAILED = 'FETCH_STANDINGS_FAILED';

export default {
  FETCH_STANDINGS_INITIATED,
  FETCH_STANDINGS_SUCCEEDED,
  FETCH_STANDINGS_FAILED,
};
